<template>
	<vue-slider v-model="val" :max="max" :min="min" />
</template>

<script>
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";

export default {
	components: {
		VueSlider,
	},
	props: {
		value: {
			required: true,
		},
		max: {
			default: 500,
		},
		min: {
			default: 0,
		},
	},
	data() {
		return {
			val: this.value,
		};
	},
	watch: {
		val(v) {
			this.$emit("input", v);
			this.$emit("change");
		},
	},
};
</script>
